import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Send } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

export default function UrgencyCTA() {
  const { lang } = useLang();

  const content = lang === 'ru' ? {
    title: 'Готовы обсудить запуск франшизы?',
    subtitle: 'Получите детали по модели, инвестициям и условиям запуска. Свяжитесь с нами напрямую — по телефону или в Telegram.',
    microcopy: 'Прямой контакт без форм — обсудим запуск лично.',
    cta_primary: 'Позвонить',
    cta_secondary: 'Написать в Telegram',
  } : {
    title: '¿Listo para discutir el lanzamiento de la franquicia?',
    subtitle: 'Obtenga los detalles sobre el modelo, inversiones y condiciones de lanzamiento. Contáctenos directamente — por teléfono o Telegram.',
    microcopy: 'Contacto directo sin formularios — discutiremos el lanzamiento personalmente.',
    cta_primary: 'Llamar',
    cta_secondary: 'Escribir por Telegram',
  };

  return (
    <section className="relative py-20 md:py-28 px-6 overflow-hidden">
      {/* Animated background gradient */}
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(135deg, rgba(212,175,55,0.12) 0%, rgba(34,197,94,0.08) 100%)',
        }}
      />
      <div
        className="absolute inset-0 opacity-50"
        style={{
          background: 'radial-gradient(circle at 30% 50%, rgba(212,175,55,0.15) 0%, transparent 50%)',
        }}
      />

      <div className="max-w-4xl mx-auto relative z-10">
        {/* Main Content */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="glass-gold rounded-3xl p-10 md:p-12 text-center"
          style={{
            boxShadow: '0 30px 80px rgba(212,175,55,0.3), inset 0 1px 0 rgba(255,215,0,0.3)',
          }}
        >
          {/* Title */}
          <h2 className="text-3xl md:text-5xl font-black font-heading gold-text mb-6 leading-tight">
            {content.title}
          </h2>

          {/* Subtitle */}
          <p className="text-white text-lg md:text-xl mb-8 font-semibold">
            {content.subtitle}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6">
            <motion.a
              href="tel:+34624586917"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.98 }}
              className="btn-call flex items-center gap-3 px-8 py-4 rounded-full text-base font-bold w-full sm:w-auto justify-center min-w-[200px] shadow-2xl"
            >
              <Phone size={20} />
              {content.cta_primary}
            </motion.a>
            <motion.a
              href="https://t.me/SerjValencia"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.98 }}
              className="btn-telegram flex items-center gap-3 px-8 py-4 rounded-full text-base font-bold w-full sm:w-auto justify-center min-w-[200px] shadow-2xl"
            >
              <Send size={20} />
              {content.cta_secondary}
            </motion.a>
          </div>

          {/* Microcopy */}
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="text-white/70 text-sm md:text-base italic mt-6"
          >
            {content.microcopy}
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
}
